import { render } from "./Notification.vue?vue&type=template&id=7d772f20"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patrykslak/Documents/lauron-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__